import * as React from 'react';

const AttachSendSvg = (props) => (
  <svg width={50} height={50} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M25 47.96C37.3104 47.96 47.29 42.1979 47.29 35.09C47.29 27.9821 37.3104 22.22 25 22.22C12.6896 22.22 2.70999 27.9821 2.70999 35.09C2.70999 42.1979 12.6896 47.96 25 47.96Z"
      fill="#F5F5F5"
    />
    <path
      d="M40.35 36.35L41.59 37.07C41.59 37.07 40.97 35.08 41.31 33.07C41.44 32.31 41.72 31.94 41.81 31.73C41.91 31.53 42.65 30.28 42 29.7C41.34 29.12 39.8 30.27 39.87 33.36C39.9 34.95 40.35 36.35 40.35 36.35Z"
      fill="#00E709"
    />
    <path
      opacity={0.3}
      d="M40.35 36.35L41.59 37.07C41.59 37.07 40.97 35.08 41.31 33.07C41.44 32.31 41.72 31.94 41.81 31.73C41.91 31.53 42.65 30.28 42 29.7C41.34 29.12 39.8 30.27 39.87 33.36C39.9 34.95 40.35 36.35 40.35 36.35Z"
      fill="black"
    />
    <path
      d="M40.92 36.73C40.9 36.73 40.88 36.72 40.88 36.7C40.88 36.69 40.41 35.39 40.43 33.31C40.45 31.22 41.55 30.1 41.56 30.09C41.58 30.07 41.61 30.07 41.62 30.09C41.64 30.11 41.64 30.14 41.62 30.15C41.61 30.16 40.54 31.25 40.51 33.31C40.49 35.38 40.95 36.66 40.95 36.67C40.96 36.69 40.95 36.72 40.92 36.73C40.93 36.73 40.93 36.73 40.92 36.73Z"
      fill="white"
    />
    <path
      d="M40.7 36.54L42.75 37.74C42.75 37.74 43.69 37.6 43.62 36.72C43.55 35.84 43.17 35.63 43.64 35.24C44.11 34.85 44.24 34.83 44.21 34.45C44.19 34.07 43.93 33.9 43.81 33.75C43.69 33.6 43.35 33.28 43.59 32.83C43.83 32.37 44.15 31.93 43.67 31.72C43.39 31.59 42.91 31.75 42.6 32.09C42.28 32.43 42.02 32.67 41.73 32.74C41.43 32.82 40.81 32.82 40.83 33.34C40.85 33.86 40.98 34.03 40.86 34.26C40.61 34.7 39.6 34.93 40.7 36.54Z"
      fill="#00E709"
    />
    <path
      d="M41.5299 37.07C41.5099 37.07 41.4899 37.05 41.4899 37.03C41.4899 37 41.2699 33.95 43.3799 31.96C43.3999 31.94 43.4299 31.94 43.4399 31.96C43.4599 31.98 43.4599 32.01 43.4399 32.02C41.3599 33.99 41.5699 36.99 41.5799 37.02C41.5799 37.05 41.5599 37.07 41.5299 37.07Z"
      fill="white"
    />
    <path
      d="M41.8999 34.46C41.8799 34.46 41.8599 34.44 41.8599 34.42C41.7999 33.61 41.2399 33.2 41.2299 33.2C41.2099 33.19 41.2099 33.16 41.2199 33.14C41.2299 33.12 41.2599 33.12 41.2799 33.13C41.2999 33.15 41.8799 33.57 41.9399 34.42C41.9399 34.44 41.9199 34.46 41.8999 34.46Z"
      fill="white"
    />
    <path
      d="M41.7399 34.98C41.7299 34.98 41.7199 34.98 41.7099 34.97C41.6899 34.95 41.6899 34.93 41.7099 34.91C41.7299 34.89 42.2599 34.31 43.4899 34.48C43.5099 34.48 43.5299 34.51 43.5299 34.53C43.5299 34.55 43.4999 34.57 43.4799 34.57C42.2999 34.41 41.7899 34.96 41.7799 34.97C41.7699 34.98 41.7599 34.98 41.7399 34.98Z"
      fill="white"
    />
    <path d="M38.41 27.35L35.55 25.68L37.25 28.02L38.41 27.35Z" fill="#00E709" />
    <path opacity={0.6} d="M38.41 27.35L35.55 25.68L37.25 28.02L38.41 27.35Z" fill="black" />
    <path
      d="M36.71 33.54L20 23.89C19.85 23.81 19.76 23.65 19.76 23.48V12.08C19.76 11.72 20.15 11.49 20.47 11.67L37.18 21.32C37.33 21.4 37.42 21.56 37.42 21.73V33.14C37.42 33.5 37.02 33.72 36.71 33.54Z"
      fill="#E0E0E0"
    />
    <path
      d="M37.25 28.02L38.4 27.35V40.86C38.4 41.11 38.27 41.34 38.05 41.46L36.91 42.12L37.25 28.02Z"
      fill="#00E709"
    />
    <path
      opacity={0.3}
      d="M37.25 28.02L38.4 27.35V40.86C38.4 41.11 38.27 41.34 38.05 41.46L36.91 42.12L37.25 28.02Z"
      fill="black"
    />
    <path
      d="M35.95 33.97L19.24 24.32C19.09 24.24 19 24.08 19 23.91V12.5C19 12.14 19.39 11.91 19.71 12.09L36.42 21.74C36.57 21.82 36.66 21.98 36.66 22.15V33.56C36.66 33.92 36.27 34.15 35.95 33.97Z"
      fill="#EBEBEB"
    />
    <path
      d="M35.19 34.42L18.48 24.77C18.33 24.69 18.24 24.53 18.24 24.36V12.95C18.24 12.59 18.63 12.36 18.95 12.54L35.66 22.19C35.81 22.27 35.9 22.43 35.9 22.6V34.01C35.9 34.37 35.51 34.6 35.19 34.42Z"
      fill="#FAFAFA"
    />
    <path
      d="M15.89 12.8V29.57C15.89 30.05 16.15 30.5 16.57 30.74L36.27 42.11C36.71 42.36 37.25 42.05 37.25 41.54V28.02L26.86 22.02L25.07 17.88C24.74 17.11 24.16 16.46 23.43 16.04L16.85 12.24C16.43 12 15.89 12.31 15.89 12.8Z"
      fill="#00E709"
    />
    <path
      opacity={0.2}
      d="M15.89 12.8V29.57C15.89 30.05 16.15 30.5 16.57 30.74L36.27 42.11C36.71 42.36 37.25 42.05 37.25 41.54V28.02L26.86 22.02L25.07 17.88C24.74 17.11 24.16 16.46 23.43 16.04L16.85 12.24C16.43 12 15.89 12.31 15.89 12.8Z"
      fill="black"
    />
    <path
      d="M31.51 31.1C31.45 31.07 31.4 31.04 31.35 31.02C31.3 29.72 30.4 28.2 29.3 27.56C28.93 27.35 28.58 27.26 28.28 27.29C27.86 25.93 26.89 24.59 25.77 23.94C24.34 23.11 23.16 23.71 23.05 25.26C22.98 25.21 22.91 25.17 22.84 25.13C21.75 24.5 20.87 25.01 20.87 26.27C20.87 27.53 21.75 29.06 22.84 29.68L31.51 34.69C32.37 35.19 33.07 34.78 33.07 33.79C33.07 32.8 32.37 31.59 31.51 31.1Z"
      fill="#00E709"
    />
    <path
      opacity={0.4}
      d="M31.51 31.1C31.45 31.07 31.4 31.04 31.35 31.02C31.3 29.72 30.4 28.2 29.3 27.56C28.93 27.35 28.58 27.26 28.28 27.29C27.86 25.93 26.89 24.59 25.77 23.94C24.34 23.11 23.16 23.71 23.05 25.26C22.98 25.21 22.91 25.17 22.84 25.13C21.75 24.5 20.87 25.01 20.87 26.27C20.87 27.53 21.75 29.06 22.84 29.68L31.51 34.69C32.37 35.19 33.07 34.78 33.07 33.79C33.07 32.8 32.37 31.59 31.51 31.1Z"
      fill="white"
    />
    <path d="M28.34 31.6L26.3 27.87L24.12 29.19L24.98 29.68V33.37L27.31 34.71V30.99L28.34 31.6Z" fill="white" />
    <path
      d="M5.95001 32.57C2.71001 29.33 2.09001 24.46 4.09002 20.6L3.17001 20.35C3.05001 20.32 3.01001 20.17 3.09001 20.08C4.36001 18.58 5.75002 17.72 6.90001 17.22C7.94001 16.78 8.80001 16.63 9.20002 16.58C9.31002 16.57 9.39002 16.68 9.35002 16.78C8.90002 17.8 8.70001 18.78 8.62001 19.6C8.53001 20.45 8.57001 21.13 8.61001 21.5C8.63001 21.65 8.48002 21.77 8.33002 21.73L7.22001 21.43C5.31001 24.8 5.79001 29.16 8.66001 32.04C11.68 35.06 16.33 35.44 19.75 33.18C15.74 36.56 9.73001 36.35 5.95001 32.57Z"
      fill="#00E709"
    />
    <path
      opacity={0.4}
      d="M5.95001 32.57C2.71001 29.33 2.09001 24.46 4.09002 20.6L3.17001 20.35C3.05001 20.32 3.01001 20.17 3.09001 20.08C4.36001 18.58 5.75002 17.72 6.90001 17.22C7.94001 16.78 8.80001 16.63 9.20002 16.58C9.31002 16.57 9.39002 16.68 9.35002 16.78C8.90002 17.8 8.70001 18.78 8.62001 19.6C8.53001 20.45 8.57001 21.13 8.61001 21.5C8.63001 21.65 8.48002 21.77 8.33002 21.73L7.22001 21.43C5.31001 24.8 5.79001 29.16 8.66001 32.04C11.68 35.06 16.33 35.44 19.75 33.18C15.74 36.56 9.73001 36.35 5.95001 32.57Z"
      fill="white"
    />
    <path
      d="M42.9607 19.8324C44.0895 19.1807 44.0912 17.0705 42.9645 15.1191C41.8378 13.1677 40.0095 12.1141 38.8807 12.7658C37.752 13.4175 37.7503 15.5277 38.877 17.4791C40.0036 19.4305 41.832 20.4841 42.9607 19.8324Z"
      fill="#00E709"
    />
    <path
      opacity={0.2}
      d="M42.9607 19.8324C44.0895 19.1807 44.0912 17.0705 42.9645 15.1191C41.8378 13.1677 40.0095 12.1141 38.8807 12.7658C37.752 13.4175 37.7503 15.5277 38.877 17.4791C40.0036 19.4305 41.832 20.4841 42.9607 19.8324Z"
      fill="black"
    />
    <path
      d="M42.787 19.9239C43.9158 19.2722 43.9175 17.162 42.7908 15.2107C41.6641 13.2593 39.8358 12.2057 38.707 12.8574C37.5783 13.5091 37.5766 15.6193 38.7033 17.5707C39.8299 19.522 41.6583 20.5756 42.787 19.9239Z"
      fill="#00E709"
    />
    <path
      d="M39.67 14.13C39.55 14.06 39.4 14.15 39.4 14.28V17.03C39.4 17.17 39.47 17.3 39.59 17.37L41.82 18.66C41.94 18.73 42.09 18.64 42.09 18.51V16.47L41.49 15.19L39.67 14.13Z"
      fill="#00E709"
    />
    <path
      opacity={0.6}
      d="M39.67 14.13C39.55 14.06 39.4 14.15 39.4 14.28V17.03C39.4 17.17 39.47 17.3 39.59 17.37L41.82 18.66C41.94 18.73 42.09 18.64 42.09 18.51V16.47L41.49 15.19L39.67 14.13Z"
      fill="white"
    />
    <path d="M41.41 15.65L41.49 15.18L42.09 16.46L41.55 16.01C41.44 15.92 41.39 15.78 41.41 15.65Z" fill="#00E709" />
    <path
      opacity={0.4}
      d="M41.41 15.65L41.49 15.18L42.09 16.46L41.55 16.01C41.44 15.92 41.39 15.78 41.41 15.65Z"
      fill="white"
    />
    <path
      d="M41.63 16.72C41.62 16.72 41.61 16.72 41.6 16.71L39.84 15.7C39.81 15.68 39.8 15.65 39.82 15.62C39.84 15.59 39.87 15.58 39.9 15.6L41.66 16.62C41.69 16.64 41.7 16.67 41.68 16.7C41.67 16.71 41.65 16.72 41.63 16.72Z"
      fill="#FAFAFA"
    />
    <path
      d="M41.63 17.32C41.62 17.32 41.61 17.32 41.6 17.31L39.84 16.29C39.81 16.27 39.8 16.24 39.82 16.21C39.84 16.18 39.87 16.17 39.9 16.19L41.66 17.21C41.69 17.23 41.7 17.26 41.68 17.29C41.67 17.31 41.65 17.32 41.63 17.32Z"
      fill="#FAFAFA"
    />
    <path
      d="M41.63 17.91C41.62 17.91 41.61 17.91 41.6 17.9L39.84 16.88C39.81 16.86 39.8 16.83 39.82 16.8C39.84 16.77 39.87 16.76 39.9 16.78L41.66 17.8C41.69 17.82 41.7 17.85 41.68 17.88C41.67 17.9 41.65 17.91 41.63 17.91Z"
      fill="#FAFAFA"
    />
    <path
      d="M37.9667 9.42314C39.0955 8.77145 39.0971 6.66124 37.9705 4.70986C36.8438 2.75849 35.0155 1.70489 33.8867 2.35658C32.758 3.00828 32.7563 5.11849 33.883 7.06986C35.0096 9.02124 36.838 10.0748 37.9667 9.42314Z"
      fill="#00E709"
    />
    <path
      opacity={0.2}
      d="M37.9667 9.42314C39.0955 8.77145 39.0971 6.66124 37.9705 4.70986C36.8438 2.75849 35.0155 1.70489 33.8867 2.35658C32.758 3.00828 32.7563 5.11849 33.883 7.06986C35.0096 9.02124 36.838 10.0748 37.9667 9.42314Z"
      fill="black"
    />
    <path
      d="M37.798 9.52332C38.9268 8.87163 38.9284 6.76142 37.8018 4.81004C36.6751 2.85867 34.8468 1.80507 33.718 2.45676C32.5893 3.10846 32.5876 5.21867 33.7143 7.17004C34.8409 9.12142 36.6693 10.175 37.798 9.52332Z"
      fill="#00E709"
    />
    <path
      d="M34.68 3.73C34.56 3.66 34.41 3.75 34.41 3.88V6.63C34.41 6.77 34.48 6.9 34.6 6.97L36.83 8.26C36.95 8.33 37.1 8.24 37.1 8.11V6.06L36.5 4.78L34.68 3.73Z"
      fill="#00E709"
    />
    <path
      opacity={0.6}
      d="M34.68 3.73C34.56 3.66 34.41 3.75 34.41 3.88V6.63C34.41 6.77 34.48 6.9 34.6 6.97L36.83 8.26C36.95 8.33 37.1 8.24 37.1 8.11V6.06L36.5 4.78L34.68 3.73Z"
      fill="white"
    />
    <path d="M36.42 5.25L36.5 4.78L37.1 6.06L36.56 5.61C36.45 5.52 36.4 5.38 36.42 5.25Z" fill="#00E709" />
    <path opacity={0.4} d="M36.42 5.25L36.5 4.78L37.1 6.06L36.56 5.61C36.45 5.52 36.4 5.38 36.42 5.25Z" fill="white" />
    <path
      d="M36.64 6.32C36.63 6.32 36.62 6.32 36.61 6.31L34.85 5.3C34.82 5.28 34.81 5.25 34.83 5.22C34.85 5.19 34.88 5.18 34.91 5.2L36.67 6.22C36.7 6.24 36.71 6.27 36.69 6.3C36.68 6.31 36.66 6.32 36.64 6.32Z"
      fill="#FAFAFA"
    />
    <path
      d="M36.64 6.92001C36.63 6.92001 36.62 6.92001 36.61 6.91001L34.85 5.89001C34.82 5.87001 34.81 5.84001 34.83 5.81001C34.85 5.78001 34.88 5.77001 34.91 5.79001L36.67 6.80001C36.7 6.82001 36.71 6.85001 36.69 6.88001C36.68 6.90001 36.66 6.92001 36.64 6.92001Z"
      fill="#FAFAFA"
    />
    <path
      d="M36.64 7.51C36.63 7.51 36.62 7.51 36.61 7.5L34.85 6.48C34.82 6.46 34.81 6.43 34.83 6.4C34.85 6.37 34.88 6.36 34.91 6.38L36.67 7.4C36.7 7.42 36.71 7.45 36.69 7.48C36.68 7.5 36.66 7.51 36.64 7.51Z"
      fill="#FAFAFA"
    />
    <path
      d="M32.6495 13.7723C33.7783 13.1206 33.7799 11.0104 32.6533 9.05902C31.5266 7.10765 29.6983 6.05405 28.5695 6.70574C27.4408 7.35744 27.4391 9.46765 28.5658 11.419C29.6924 13.3704 31.5208 14.424 32.6495 13.7723Z"
      fill="#00E709"
    />
    <path
      opacity={0.2}
      d="M32.6495 13.7723C33.7783 13.1206 33.7799 11.0104 32.6533 9.05902C31.5266 7.10765 29.6983 6.05405 28.5695 6.70574C27.4408 7.35744 27.4391 9.46765 28.5658 11.419C29.6924 13.3704 31.5208 14.424 32.6495 13.7723Z"
      fill="black"
    />
    <path
      d="M32.4808 13.8725C33.6096 13.2208 33.6112 11.1106 32.4846 9.15921C31.3579 7.20783 29.5296 6.15424 28.4008 6.80593C27.2721 7.45763 27.2704 9.56783 28.3971 11.5192C29.5237 13.4706 31.3521 14.5242 32.4808 13.8725Z"
      fill="#00E709"
    />
    <path
      d="M29.36 8.07C29.24 8 29.09 8.09 29.09 8.22V10.97C29.09 11.11 29.16 11.24 29.28 11.31L31.51 12.6C31.63 12.67 31.78 12.58 31.78 12.45V10.4L31.18 9.12L29.36 8.07Z"
      fill="#00E709"
    />
    <path
      opacity={0.6}
      d="M29.36 8.07C29.24 8 29.09 8.09 29.09 8.22V10.97C29.09 11.11 29.16 11.24 29.28 11.31L31.51 12.6C31.63 12.67 31.78 12.58 31.78 12.45V10.4L31.18 9.12L29.36 8.07Z"
      fill="white"
    />
    <path d="M31.1 9.59L31.18 9.12L31.78 10.4L31.24 9.95C31.13 9.87 31.08 9.73 31.1 9.59Z" fill="#00E709" />
    <path opacity={0.4} d="M31.1 9.59L31.18 9.12L31.78 10.4L31.24 9.95C31.13 9.87 31.08 9.73 31.1 9.59Z" fill="white" />
    <path
      d="M31.32 10.66C31.31 10.66 31.3 10.66 31.29 10.65L29.53 9.63001C29.5 9.61001 29.49 9.58 29.51 9.55C29.53 9.52 29.56 9.51001 29.59 9.53001L31.35 10.55C31.38 10.57 31.39 10.6 31.37 10.63C31.36 10.65 31.34 10.66 31.32 10.66Z"
      fill="#FAFAFA"
    />
    <path
      d="M31.32 11.26C31.31 11.26 31.3 11.26 31.29 11.25L29.53 10.23C29.5 10.21 29.49 10.18 29.51 10.15C29.53 10.12 29.56 10.11 29.59 10.13L31.35 11.15C31.38 11.17 31.39 11.2 31.37 11.23C31.36 11.25 31.34 11.26 31.32 11.26Z"
      fill="#FAFAFA"
    />
    <path
      d="M31.32 11.86C31.31 11.86 31.3 11.86 31.29 11.85L29.53 10.83C29.5 10.81 29.49 10.78 29.51 10.75C29.53 10.72 29.56 10.71 29.59 10.73L31.35 11.75C31.38 11.77 31.39 11.8 31.37 11.83C31.36 11.85 31.34 11.86 31.32 11.86Z"
      fill="#FAFAFA"
    />
    <path
      d="M35.91 10.05C35.87 10.05 35.84 10.02 35.84 9.98V9.79C35.84 9.75 35.87 9.72 35.91 9.72C35.95 9.72 35.98 9.75 35.98 9.79V9.98C35.99 10.02 35.95 10.05 35.91 10.05Z"
      fill="#00E709"
    />
    <path
      d="M35.91 20.63C35.87 20.63 35.84 20.6 35.84 20.56V20.18C35.84 20.14 35.87 20.11 35.91 20.11C35.95 20.11 35.98 20.14 35.98 20.18V20.56C35.99 20.6 35.95 20.63 35.91 20.63ZM35.91 19.87C35.87 19.87 35.84 19.84 35.84 19.8V19.42C35.84 19.38 35.87 19.35 35.91 19.35C35.95 19.35 35.98 19.38 35.98 19.42V19.8C35.99 19.84 35.95 19.87 35.91 19.87ZM35.91 19.12C35.87 19.12 35.84 19.09 35.84 19.05V18.67C35.84 18.63 35.87 18.6 35.91 18.6C35.95 18.6 35.98 18.63 35.98 18.67V19.05C35.99 19.09 35.95 19.12 35.91 19.12ZM35.91 18.36C35.87 18.36 35.84 18.33 35.84 18.29V17.91C35.84 17.87 35.87 17.84 35.91 17.84C35.95 17.84 35.98 17.87 35.98 17.91V18.29C35.99 18.33 35.95 18.36 35.91 18.36ZM35.91 17.61C35.87 17.61 35.84 17.58 35.84 17.54V17.16C35.84 17.12 35.87 17.09 35.91 17.09C35.95 17.09 35.98 17.12 35.98 17.16V17.54C35.99 17.58 35.95 17.61 35.91 17.61ZM35.91 16.85C35.87 16.85 35.84 16.82 35.84 16.78V16.4C35.84 16.36 35.87 16.33 35.91 16.33C35.95 16.33 35.98 16.36 35.98 16.4V16.78C35.99 16.82 35.95 16.85 35.91 16.85ZM35.91 16.1C35.87 16.1 35.84 16.07 35.84 16.03V15.65C35.84 15.61 35.87 15.58 35.91 15.58C35.95 15.58 35.98 15.61 35.98 15.65V16.03C35.99 16.06 35.95 16.1 35.91 16.1ZM35.91 15.34C35.87 15.34 35.84 15.31 35.84 15.27V14.89C35.84 14.85 35.87 14.82 35.91 14.82C35.95 14.82 35.98 14.85 35.98 14.89V15.27C35.99 15.31 35.95 15.34 35.91 15.34ZM35.91 14.59C35.87 14.59 35.84 14.56 35.84 14.52V14.14C35.84 14.1 35.87 14.07 35.91 14.07C35.95 14.07 35.98 14.1 35.98 14.14V14.52C35.99 14.55 35.95 14.59 35.91 14.59ZM35.91 13.83C35.87 13.83 35.84 13.8 35.84 13.76V13.38C35.84 13.34 35.87 13.31 35.91 13.31C35.95 13.31 35.98 13.34 35.98 13.38V13.76C35.99 13.8 35.95 13.83 35.91 13.83ZM35.91 13.07C35.87 13.07 35.84 13.04 35.84 13V12.62C35.84 12.58 35.87 12.55 35.91 12.55C35.95 12.55 35.98 12.58 35.98 12.62V13C35.99 13.04 35.95 13.07 35.91 13.07ZM35.91 12.32C35.87 12.32 35.84 12.29 35.84 12.25V11.87C35.84 11.83 35.87 11.8 35.91 11.8C35.95 11.8 35.98 11.83 35.98 11.87V12.25C35.99 12.29 35.95 12.32 35.91 12.32ZM35.91 11.56C35.87 11.56 35.84 11.53 35.84 11.49V11.11C35.84 11.07 35.87 11.04 35.91 11.04C35.95 11.04 35.98 11.07 35.98 11.11V11.49C35.99 11.53 35.95 11.56 35.91 11.56ZM35.91 10.81C35.87 10.81 35.84 10.78 35.84 10.74V10.36C35.84 10.32 35.87 10.29 35.91 10.29C35.95 10.29 35.98 10.32 35.98 10.36V10.74C35.99 10.78 35.95 10.81 35.91 10.81Z"
      fill="#00E709"
    />
    <path
      d="M35.91 21.2C35.87 21.2 35.84 21.17 35.84 21.13V20.94C35.84 20.9 35.87 20.87 35.91 20.87C35.95 20.87 35.98 20.9 35.98 20.94V21.13C35.99 21.16 35.95 21.2 35.91 21.2Z"
      fill="#00E709"
    />
    <path
      d="M37.7 16.55C37.67 16.55 37.65 16.54 37.64 16.51C37.62 16.47 37.64 16.43 37.67 16.41L37.84 16.33C37.88 16.31 37.92 16.33 37.93 16.36C37.95 16.4 37.93 16.44 37.9 16.46L37.73 16.54C37.72 16.55 37.71 16.55 37.7 16.55Z"
      fill="#00E709"
    />
    <path
      d="M36.87 16.96C36.84 16.96 36.82 16.95 36.81 16.92C36.79 16.88 36.81 16.84 36.84 16.83L37.26 16.62C37.3 16.6 37.34 16.62 37.35 16.65C37.37 16.69 37.35 16.73 37.32 16.74L36.9 16.95C36.89 16.96 36.88 16.96 36.87 16.96Z"
      fill="#00E709"
    />
    <path
      d="M36.28 17.25C36.25 17.25 36.23 17.24 36.22 17.21C36.2 17.17 36.22 17.13 36.25 17.11L36.42 17.03C36.46 17.01 36.5 17.03 36.51 17.06C36.53 17.1 36.51 17.14 36.48 17.16L36.31 17.24C36.3 17.25 36.29 17.25 36.28 17.25Z"
      fill="#00E709"
    />
    <path
      d="M33.67 12.13C33.65 12.13 33.62 12.12 33.61 12.1L33.51 11.94C33.49 11.91 33.5 11.86 33.53 11.84C33.56 11.82 33.61 11.83 33.63 11.86L33.73 12.02C33.75 12.05 33.74 12.1 33.71 12.12C33.69 12.13 33.68 12.13 33.67 12.13Z"
      fill="#00E709"
    />
    <path
      d="M35.22 14.69C35.2 14.69 35.17 14.68 35.16 14.66L34.97 14.34C34.95 14.31 34.96 14.26 34.99 14.24C35.02 14.22 35.07 14.23 35.09 14.26L35.28 14.58C35.3 14.61 35.29 14.66 35.26 14.68C35.24 14.69 35.23 14.69 35.22 14.69ZM34.83 14.05C34.81 14.05 34.78 14.04 34.77 14.02L34.58 13.7C34.56 13.67 34.57 13.62 34.6 13.6C34.63 13.58 34.68 13.59 34.7 13.62L34.89 13.94C34.91 13.97 34.9 14.02 34.87 14.04C34.85 14.05 34.84 14.05 34.83 14.05ZM34.44 13.41C34.42 13.41 34.39 13.4 34.38 13.38L34.19 13.06C34.17 13.03 34.18 12.98 34.21 12.96C34.24 12.94 34.29 12.95 34.31 12.98L34.5 13.3C34.52 13.33 34.51 13.38 34.48 13.4C34.47 13.41 34.45 13.41 34.44 13.41ZM34.05 12.77C34.03 12.77 34 12.76 33.99 12.74L33.8 12.42C33.78 12.39 33.79 12.34 33.82 12.32C33.85 12.3 33.9 12.31 33.92 12.34L34.11 12.66C34.13 12.69 34.12 12.74 34.09 12.76C34.08 12.77 34.07 12.77 34.05 12.77Z"
      fill="#00E709"
    />
    <path
      d="M35.51 15.17C35.49 15.17 35.46 15.16 35.45 15.14L35.35 14.98C35.33 14.95 35.34 14.9 35.37 14.88C35.4 14.86 35.45 14.87 35.47 14.9L35.57 15.06C35.59 15.09 35.58 15.14 35.55 15.16C35.53 15.17 35.52 15.17 35.51 15.17Z"
      fill="#00E709"
    />
  </svg>
);
export default AttachSendSvg;
